"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var _1ds_core_js_1 = require("@microsoft/1ds-core-js");
var Types_1 = require("../Types");
var OverrideablePropertyMap = (function () {
    function OverrideablePropertyMap() {
        var _this = this;
        this.ProviderOverride = undefined;
        this.GetForEvent = function (eventType) {
            var _a, _b, _c;
            return (_c = (_b = (_a = _this._eventOverrides) === null || _a === void 0 ? void 0 : _a.get(eventType), (_b !== null && _b !== void 0 ? _b : _this.ProviderOverride)), (_c !== null && _c !== void 0 ? _c : _this.GetDefaultForEvent(eventType)));
        };
        this.OverrideForEvent = function (eventType, property) {
            var _a;
            if (property) {
                if (!_this._eventOverrides) {
                    _this._eventOverrides = new Map();
                }
                try {
                    _this._eventOverrides.set(eventType, property);
                }
                catch (err) {
                    throw new Error("GamingTelemetry: Failed to set value '" + property + "' for GtlEventType." + eventType);
                }
            }
            else {
                (_a = _this._eventOverrides) === null || _a === void 0 ? void 0 : _a["delete"](eventType);
            }
        };
    }
    return OverrideablePropertyMap;
}());
var PrivacyTagProperties = (function (_super) {
    __extends(PrivacyTagProperties, _super);
    function PrivacyTagProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivacyTagProperties.prototype.GetDefaultForEvent = function (eventType) {
        switch (eventType) {
            case Types_1.GtlEventType.Error:
                return Types_1.PrivacyTag.ProductAndServicePerformance;
            default:
                return Types_1.PrivacyTag.ProductAndServiceUsage;
        }
    };
    return PrivacyTagProperties;
}(OverrideablePropertyMap));
exports.PrivacyTagProperties = PrivacyTagProperties;
var EventKeywordProperties = (function (_super) {
    __extends(EventKeywordProperties, _super);
    function EventKeywordProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventKeywordProperties.prototype.GetDefaultForEvent = function (eventType) {
        return Types_1.EventKeyword.Measure;
    };
    return EventKeywordProperties;
}(OverrideablePropertyMap));
exports.EventKeywordProperties = EventKeywordProperties;
var EventPersistenceProperties = (function (_super) {
    __extends(EventPersistenceProperties, _super);
    function EventPersistenceProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventPersistenceProperties.prototype.GetDefaultForEvent = function (eventType) {
        return _1ds_core_js_1.EventPersistence.Normal;
    };
    return EventPersistenceProperties;
}(OverrideablePropertyMap));
exports.EventPersistenceProperties = EventPersistenceProperties;
var GroupIdTypeProperties = (function (_super) {
    __extends(GroupIdTypeProperties, _super);
    function GroupIdTypeProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupIdTypeProperties.prototype.GetDefaultForEvent = function (eventType) {
        return Types_1.GtlGroupIdType.OptionalDiagnostic;
    };
    return GroupIdTypeProperties;
}(OverrideablePropertyMap));
exports.GroupIdTypeProperties = GroupIdTypeProperties;
var EventLatencyProperties = (function (_super) {
    __extends(EventLatencyProperties, _super);
    function EventLatencyProperties() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventLatencyProperties.prototype.GetDefaultForEvent = function (eventType) {
        return _1ds_core_js_1.EventLatency.Normal;
    };
    return EventLatencyProperties;
}(OverrideablePropertyMap));
exports.EventLatencyProperties = EventLatencyProperties;
//# sourceMappingURL=OverrideableProperties.js.map